import { render, staticRenderFns } from "./surface_post_attachment_new.vue?vue&type=template&id=b938bcfe&"
import script from "./surface_post_attachment_new.vue?vue&type=script&lang=ts&"
export * from "./surface_post_attachment_new.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports